import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Field } from "@/components/common";
import { CashOpenPrint } from "@/components/cash/CashOpenPrint";
import { useAuth } from "@/context/AuthContext";
import { directPrint } from "@/lib/qz";
import { cashOpen } from "@/lib/receipts";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function OpenCashDialog({ mode, defaultUserId, onClose, onDone }) {
  const [ops, setOps] = useState([]);
  const [sel, setSel] = useState([]);
  const [userId, setUserId] = useState("");
  const [value, setValue] = useState("");
  const [printed, setPrinted] = useState(null);
  const { session } = useAuth();
  const ticket = mode === "ticket";
  useEffect(() => {
    api.get("/cash/operators").then((r) => {
      const list = r.data.filter((u) => (ticket ? u.sale_mode !== "pdv" : u.sale_mode !== "ticket"));
      setOps(list);
      if (ticket && list.some((u) => u.id === defaultUserId)) setUserId(defaultUserId);
    }).catch((e) => toast.error(errMsg(e)));
  }, [ticket, defaultUserId]);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const submit = async () => {
    try {
      const body = ticket ? { opening_amount: Number(value) || 0, user_id: userId } : { opening_amount: Number(value) || 0, user_ids: sel };
      const { data } = await api.post("/cash/open", body, { params: { mode } });
      toast.success("Caixa aberto");
      if (await directPrint(session, "cash", (pr) => cashOpen(data, session.tenant.nome_fantasia, pr))) return onDone();
      setPrinted(data);
      setTimeout(() => { window.print(); onDone(); }, 300);
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  if (printed) return <CashOpenPrint s={printed} store={session.tenant.nome_fantasia} />;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="open-cash-modal">
        <DialogHeader><DialogTitle>{ticket ? "Abrir caixa da Venda ticket" : "Abrir caixa PDV"}</DialogTitle>
          <DialogDescription>{ticket ? "Cada usuário da Venda ticket tem o próprio caixa." : "Caixa único: marque os usuários que vão vender nele. Usuários só da Venda ticket têm caixa próprio."}</DialogDescription></DialogHeader>
        {ticket ? (
          <Field label="Usuário">
            <Select value={userId} onValueChange={setUserId}>
              <SelectTrigger data-testid="open-cash-user-select"><SelectValue placeholder="Selecione o usuário" /></SelectTrigger>
              <SelectContent>{ops.map((u) => <SelectItem key={u.id} value={u.id} data-testid={`open-cash-user-option-${u.id}`}>{u.name}</SelectItem>)}</SelectContent>
            </Select>
          </Field>
        ) : (
          <Field label="Usuários liberados neste caixa">
            <div className="max-h-56 space-y-1 overflow-y-auto rounded-lg border p-2" data-testid="open-cash-users">
              <button type="button" className="text-xs text-primary" onClick={() => setSel(sel.length === ops.length ? [] : ops.map((u) => u.id))} data-testid="open-cash-select-all">{sel.length === ops.length ? "Desmarcar todos" : "Marcar todos"}</button>
              {ops.map((u) => (
                <label key={u.id} className="flex items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-accent cursor-pointer">
                  <Checkbox checked={sel.includes(u.id)} onCheckedChange={() => toggle(u.id)} data-testid={`open-cash-user-${u.id}`} />{u.name}
                </label>
              ))}
            </div>
          </Field>
        )}
        <Field label="Valor inicial em dinheiro (troco)"><Input type="number" step="0.01" min="0" value={value} onChange={(e) => setValue(e.target.value)} className="h-11 font-mono" data-testid="open-cash-amount-input" /></Field>
        <DialogFooter><Button onClick={submit} disabled={ticket ? !userId : !sel.length} data-testid="open-cash-confirm-btn">Abrir caixa</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
